import { apiClient } from './client.js';
import type { AvailableSlot } from '@atomfit/shared';

export interface CreateBookingIntentResponse {
  token: string;
  expiresAt: string;
}

export interface BookingIntentResponse {
  gymId: string;
  tenant: { slug: string };
  slot: AvailableSlot;
  slots: AvailableSlot[];
  offerCode: string | null;
  notes: string | null;
}

export const bookingIntentsApi = {
  create: (gymId: string, slotStartTime: string, offerCode?: string, notes?: string) =>
    apiClient.post<CreateBookingIntentResponse>('/booking-intents', {
      gymId,
      slotStartTime,
      offerCode,
      notes,
    }),
  createBatch: (gymId: string, slotStartTimes: string[], offerCode?: string, notes?: string) =>
    apiClient.post<CreateBookingIntentResponse>('/booking-intents', {
      gymId,
      slotStartTime: slotStartTimes[0],
      slotStartTimes,
      offerCode,
      notes,
    }),

  get: (token: string) =>
    apiClient.get<BookingIntentResponse>(`/booking-intents/${encodeURIComponent(token)}`),
};
